/**
 * @prettier
 * @flow
 */
export const es = {
    'Payment Link': 'Link de pago',
    '@company - Payment Links': '@company - Links de pago',
    'Create': 'Crear',
    'Created': 'Creado',
    'Status': 'Estatus',
    'Payment Reason': 'Motivo de cobro',
    'Customer Name': 'Nombre del cliente',
    'Total Amount': 'Monto total',
    'Actions': 'Acciones',

    'Hello @customer, you received a @amount payment request from @company': 'Hola @customer, recibiste un Link de Pago de @company por @amount',
    'Contact Details': 'Información de contacto',
    'Phone Number': 'Numero de telefono',
    'Card Number': 'Número de tarjeta',
    'Card Details': 'Información de la tarjeta',
    'Exp.': 'Exp',
    'Exp. Month': 'Mes exp',
    'Exp. Year': 'Año exp',
    'MM/YY': 'MM/AA',
    'CVV': 'CVV',
    'What is this?': '¿Qué es esto?',
    'Cardholder Name': 'Nombre del tarjetahabiente',
    'Shipping Details': 'Información de envío',
    'Address Line 1': 'Línea 1 de dirección',
    'Address Line 2': 'Línea 2 de dirección',
    'Zip Code': 'Código postal',
    'City': 'Ciudad',
    'State': 'Estado',
    'Continue': 'Siguiente',
    'Pay @amount': 'Pagar @amount',
    'By continuing I am accepting the terms and conditions of the service.': 'Al continuar estoy aceptando los términos y condiciones del servicio.',
    'terms and conditions': 'términos y condiciones',
    '3 digits': '3 dígitos',
    '4 digits': '4 dígitos',

    'Days to Expiration': 'Días de vigencia',
    'Email': 'Correo electrónico',
    'Expires': 'Expira',
    'Expires in': 'Expira en',

    'Sorry, no matching records found': 'Disculpa, no se encontró',
    'Sort': 'Ordenar',
    'Sort for @column': 'Ordenar por @column',
    'Next Page': 'Siguiente página',
    'Previous Page': 'Página anterior',
    'Rows per page:': 'Filas por página:',
    'of': 'de',
    'Search': 'Búsqueda',
    'Download CSV': 'Descargar CSV',
    'Print': 'Imprimir',
    'View Columns': 'Ver Columnas',
    'Filter Table': 'Filtrar Tabla',
    'All': 'Todos',
    'FILTERS': 'FILTROS',
    'RESET': 'REINICIAR',
    'Show Columns': 'Mostrar Columnas',
    'Show/Hide Table Columns': 'Mostrar/Esconder Columnas de Tabla',
    'row(s) selected': 'fila(s) seleccionada',
    'Delete': 'Eliminar',
    'Delete Selected Rows': 'Eliminar filas seleccionadas',

    'Page Not Found': 'Página no encontrada',

    'Back': 'Atrás',
    'Copy to Clipboard': 'Copiar en Portapapeles',
    'Copy Payment Link': 'Copiar Link de Pago',
    'Cancel Payment Link': 'Cancelar Link de Pago',
    'Copied!': '¡Copiado!',
    'Create new Payment Link': 'Crear nuevo Link de Pago',
    'Are you sure you want to Cancel this payment link?': '¿Desea Cancelar este Link de Pago?',
    'Are you sure you want to Cancel this payment?': '¿Desea Cancelar la transacción?',
    'Are you sure you want to Refund this payment?': '¿Desea Devolver la transacción?',
    'Cancel': 'Cancelar',
    'Refund': 'Devolver',
    'Cancelled Successfully!': '¡Operación Cancelada exitosamente!',
    'Refunded Successfully!': '¡Operación Devuelta exitosamente!',

    'This field is required': 'Este dato es necesario',
    'Must be a number less than @number': 'Debe ser un número menor a @number',
    'Must be a number larger than @number': 'Debe ser un número mayor a @number',
    'Must be at least @number characters': 'Debe ser mínimo de @number caracteres',
    'Must be at most @number characters': 'Debe ser máximo de @number caracteres',

    'Email is required': 'Correo requerido',
    'Invalid email': 'Correo inválido',
    'Phone number is required': 'Número de teléfono requerido',
    'Invalid phone number': 'Número de teléfono inválido',
    'Must be an email': 'Debe ser un correo',
    'Card number is required': 'Número de tarjeta es requerido',
    'Invalid card number': 'Número de tarjeta inválido ',
    'CVV is required': 'CVV requerido',
    'CVV must be at least @number characters': 'CVV debe ser al menos de @number dígitos',
    'CVV must be at most @number characters': 'CVV debe ser máximo de @number dígitos',
    'Expiry is required': 'Fecha de vencimiento requerida',
    'Expiry must be in format MM/YY': 'Fecha de vencimiento debe ser en formato MM/AA',
    'Shipping address is required': 'Dirección de envío requerida',

    'Terms and Conditions': 'Términos y Condiciones',
    'Privacy': 'Aviso de Privacidad',
    'Reason': 'Concepto',

    'Refresh': 'Actualizar',

    'PaymentLinkStatuses.ACTIVE': 'Activo',
    'PaymentLinkStatuses.PAID': 'Pagado',
    'PaymentLinkStatuses.CANCELLED': 'Cancelado',
    'PaymentLinkStatuses.PAYMENT_CANCELLED': 'Cancelado',
    'PaymentLinkStatuses.PAYMENT_REFUNDED': 'Devuelto',
    'PaymentLinkStatuses.EXPIRED': 'Expirado',

    'Create Payment Link': 'Crear link de pago',
    'Signing in failed': 'Error al iniciar sesión',
    'Sign In': 'Iniciar sesión',
    'Sign Out': 'Cerrar sesión',
    'Password': 'Contraseña',
    'Network error, please check your internet connection.': 'Error de red, verifique su conexión a Internet.',
    'Failed to sign in, please check your email and password.': 'Error al iniciar sesión, verifique su correo electrónico y contraseña.',
    'Failed to sign in, please try again if problem persists please contact support.': 'No se pudo iniciar sesión. Inténtelo de nuevo. Si el problema persiste, comuníquese con el servicio de asistencia.',
    'Singed out since have been signed in for too long.': 'Desconectado desde que estuve registrado durante demasiado tiempo.',
    'Please sign in again.': 'Por favor inicie sesión nuevamente.',
    'Ask for Shipping Address': 'Preguntar por la dirección de envío',
    'Months without Interest': 'Meses sin intereses',
    'No promotion': 'Sin promoción',
};
